/* eslint-disable max-len */
import React from 'react';
import CardHolder from '../../../components/CardHolder';
import { HOME_URL } from '../../../config/config';
import './FAQItem.scss';

export default function PaymentFees({ eventKey }) {
  return (
    <div className="faqitem">
      {/* <Accordion defaultActiveKey={eventKey}> */}

      <CardHolder
        id="fareRules"
        eventKey="fareRules"
        selectedEventKey={eventKey}
        header="What are Fare Rules?"
      >
        <p>
          The rules and conditions of any reservation depend upon the fare type that the reservation has been made under. These rules and applicable conditions for a particular fare type are called Fare Rules.
        </p>
        <p>
          Given below are the Fare Rules applicable to the three different type of fares offered by allianceair:
        </p>

        <table className="allianceairTable">
          <tr>
            <th>Other Fare Rules</th>
            <th>Return Fare</th>
            <th>Group Fare</th>
          </tr>
          <tr>
            <td>
              Applicability
            </td>
            <td>
              Only  available on Domestic sectors, subject to seat availability
            </td>
            <td>
              More than 9 passengers may be booked as a group, for the same you may write to us at
              <a href="mailto:groups@allianceair.in">groups@allianceair.in</a>
            </td>
          </tr>

          <tr>
            <td>Change/Cancellations</td>
            <td>
              <p>Yes, you can cancel or change your Return Fare booking.</p>
              <p>Please refer Conditions of Carriage for change/cancellation fee and detailed T&Cs.</p>
            </td>
            <td>
              Yes, you can cancel or change your Group Fare booking.
            </td>
          </tr>

          <tr>
            <td>
              Switch to other fare type
            </td>
            <td>
              <p>
                You cannot switch to any other option of fares.
              </p>
              <p>
                Any such change will be considered a change of booking and the applicable change fee and difference of fare will accordingly apply.
              </p>
            </td>
            <td>NA</td>
          </tr>

          <tr>
            <td>Partial Cancellation</td>
            <td>You can partially cancel a booking on Return Fare</td>
            <td>NA</td>
          </tr>
        </table>

      </CardHolder>

      <CardHolder
        eventKey="BigliteFare"
        selectedEventKey={eventKey}
        id="BigliteFare"
        header="What is Biglite Fare?"
      >
        <p>Biglite are promo fares valid only with Hand – Baggage and restrictive fare conditions.</p>
      </CardHolder>

      <CardHolder
        selectedEventKey={eventKey}
        id="BigEasyFare"
        eventKey="BigEasyFare"
        header="What is BigEasy Fare?"
      >
        <p>BigEasy Fares is for guests who have dynamic travel needs and may change their travel plans often.</p>
      </CardHolder>

      <CardHolder
        id="groupFare"
        selectedEventKey={eventKey}
        eventKey="groupFare"
        header="What is Group Fare?"
      >
        <p>
          More than 9 passengers may be booked as a group, for the same you may write to us at

          <a href="mailto:groups@allianceair.in">groups@allianceair.in</a>
        </p>

      </CardHolder>

      <CardHolder
        id="defence"
        selectedEventKey={eventKey}
        eventKey="defence"
        header="What is Defence category?"
      >
        <p>
          Upto 50% discount on base fare is provided for bookings made under Defence category and is open to serving and retired Defence and paramilitary personnel. This offer cannot be clubbed with any other promotional scheme or discount offer extended by allianceair. The discount of upto 50% shall be reduced to the extent of any other promotional scheme available such that the overall discount does not exceed 50%.
        </p>

        <p>
          Defence reservations can be booked only through allianceair official website
          {' '}
          <a href={`${HOME_URL}`}>www.allianceair.in</a>
        </p>

        <strong>Number of seats under Defence Category</strong>
        <p>
          There are restricted inventory available, which is served on first come first serve basis. In case the inventory is exhausted under this category, you may choose to fly a different date or select a normal class fare to check the availability on the same date.
        </p>

        <strong>Family</strong>
        <p>
          The special offer is open to serving and retired Defence and paramilitary personnel and their families.
        </p>

        <strong>Required Documents</strong>
        <p>
          Travellers would be required to produce their Military ID card/ Dependent card at the time of check-in/airport entry for verification. Passengers will be denied boarding in case they fail the verification stage during the check-in process, also the ticket will stand cancel if the valid Military ID / Dependent card is not provided. A fresh ticket needs to be purchased
        </p>

        <strong>Rescheduling</strong>
        <p>
          The reservation booked under Armed Forces Personnel Discount category can be modified with NIL charges, the ticket cancellation & No-Show would attract charges as per the normal cancellation policy. Also this fare cannot be clubbed with any other fare, hence if seat not available on the specified date, need to book date with seat available.
        </p>

      </CardHolder>

      <CardHolder
        id="senior"
        eventKey="senior"
        selectedEventKey={eventKey}
        header="What is Senior Citizen Fare?"
      >

        <p>
          Upto 6% discount on base fare is provided for bookings made under Senior Citizen with the age limit of 60 and above. This offer cannot be clubbed with any other promotional scheme or discount offer extended by allianceair. The discount of upto 6% shall be reduced to the extent of any other promotional scheme available such that the overall discount does not exceed 6%.
        </p>

        <p>
          Senior Citizen reservations can be booked only through allianceair official website
          {' '}
          <a href={`${HOME_URL}`}>www.allianceair.in</a>
        </p>

        <strong>Number of seats under Senior Citizen</strong>
        <p>
          There is limited inventory available, which is served on first come first serve basis. In case the inventory is exhausted under this category, you may choose to fly a different date or select a normal class fare to check the availability on the same date.
        </p>

        <strong>Family</strong>
        <p>
          The special offer is open to Senior citizen only and not their families.
        </p>

        <strong>Required Documents</strong>
        <p>
          Travellers would be required to produce their Senior Citizen Card or Any ID Proof with Age or Birth Date at the time of check-in/airport entry for verification. Passengers will be denied boarding in case they fail the verification stage during the check-in process, also the ticket will stand cancel if the valid ID Proof is not provided, A fresh ticket needs to be purchased
        </p>

        <strong>Rescheduling and Cancellation</strong>
        <p>
          The reservation booked under Senior Citizen Discount category can be modified with NIL charges, the ticket cancellation & No-Show would attract charges as per the normal cancellation policy. Also this fare cannot be clubbed with any other fare, hence if seat not available on the specified date, need to book date with seat available.
        </p>
      </CardHolder>

      <CardHolder
        id="groupReservation"
        eventKey="groupReservation"
        selectedEventKey={eventKey}
        header="What is group Reservation?"
      >

        <p>A group is defined as 10 or more passengers travelling together in one reservation.</p>
        <p>
          For all your group queries we request you to send email to
          <a href="mailto:groups@allianceair.in">groups@allianceair.in</a>
          {' '}
          with your group request and the airline shall revert within 24hours.
        </p>
        <p>
          <strong>Note:</strong>
          {' '}
          if you are a travel partner with us, you are requested to login on our website (
          <a href={`${HOME_URL}`}>www.allianceair.in</a>
          ), else you can contact our local Sales Agent in your city for becoming a Travel Partner.
        </p>
        <p>With your travel partner login id and raise your groups queries.</p>
        <p>For any other assistance kindly contact us on below ids-:</p>
        <p>
          Direct passengers-:
          <a href="mailto:groups@allianceair.in">groups@allianceair.in</a>
        </p>
      </CardHolder>

      <CardHolder
        id="student"
        eventKey="student"
        selectedEventKey={eventKey}
        header="What is student fare?"
      >

        <p>Upto 10% discount on base fare is provided for bookings made under Student Fare with the age limit of 12yrs to 18yrs. This offer cannot be clubbed with any other promotional scheme or discount offer extended by allianceair. The discount of upto 10% shall be reduced to the extent of any other promotional scheme available such that the overall discount does not exceed 10%.</p>
        <p>
          Student Fare reservations can be booked only through allianceair official website
          <a href={`${HOME_URL}`}>www.allianceair.in</a>
        </p>

        <strong>Number of seats under Student Fare</strong>
        <p>
          There is limited inventory available, which is served on first come first serve basis. In case the inventory is exhausted under this category, you may choose to fly a different date or select a normal class fare to check the availability on the same date.
        </p>

        <strong>Family</strong>
        <p>
          The special offer is open to Students only and not their families.
        </p>

        <strong>Required Documents</strong>
        <p>
          Travellers would be required to produce their Valid Student Identity Card of the Institution at the time of check-in/airport entry for verification. Passengers will be denied boarding in case they fail the verification stage during the check-in process, also the ticket will stand cancel if the valid ID Proof is not provided, A fresh ticket needs to be purchased
        </p>

        <strong>Rescheduling & Cancellation</strong>
        <p>
          The reservation booked under Student Fare category can be modified with NIL charges, the ticket cancellation & No-Show would attract charges as per the normal cancellation policy. Also this fare cannot be clubbed with any other fare, hence if seat not available on the specified date, need to book date with seat available
        </p>
      </CardHolder>

      <CardHolder
        id="coronaWarrior"
        eventKey="coronaWarrior"
        selectedEventKey={eventKey}
        header="What is Corona Warrior Category?"
      >
        <strong>Terms and Conditions:</strong>
        <ol>
          <li>
            <strong>Eligibility:</strong>

            <p>
              Doctors / nurses / policemen (
              <u>“Corona Warriors”</u>
              ) booking allianceair flights through allianceair’s website (
              <a href={HOME_URL}>www.allianceair.in</a>
              ) shall be eligible for up to twenty five (25%) discount on certain allianceair flights
            </p>
          </li>
          <li>
            <strong>Validity:</strong>

            <p>
              The Offer is available for certain flights, operated by allianceair, for booking and travel undertaken by a guest on or before December 31, 2020  (“Offer Period”) on any of the booking platforms.
            </p>
          </li>
          <li>
            <strong>Identification:</strong>
            <p>
              A valid Medical Council of India (MCI) or State Medical Council registration number for doctors has to be submitted at the time of
              <u>checkin</u>
              {' '}
              and the original/self-attested copy of the registration certificate along with a photo identification card is mandatorily required to be shown by a passenger at the time of check-in.
            </p>
            <p>
              A valid Indian Nursing Council (INC) registration number or a Degree or Diploma certificate number for nurses has to be submitted at the time of
              <u>checkin</u>
              {' '}
              and the original certificate or a copy of the certificate duly attested by a doctor along with a photo identification card is mandatorily required to be shown by passenger at the time of check-in. In the absence of the aforesaid documents, nurses can also provide the letter of identification for themselves certified by a doctor on the doctors’ letterhead along with a stamped and certified photograph.
            </p>
            <p>A valid photo Identification card to be produced issued and stamped by the government to be produced at the time of checkin</p>
            <p>Passengers who fail to provide a valid identification, at the time of checkin, will be denied boarding.</p>
          </li>
          <li>
            <strong>Manner of Use:</strong>
            <p>
              (a) While making a booking, the guest is required to select the ‘check box’ for the
              <u>“Corona Warriors”</u>
              {' '}
              fare on the homepage. The discount will be automatically applied to the applicable fare. Limited inventory is available under the Scheme and bookings are subject to availability and at the sole discretion of allianceair on first come first served basis. If the inventory is exhausted under this category, a guest may choose to fly on a different date or select a normal class of fare for the same date.
            </p>
            <p>(b) The doctor / nurse / policemen whose details have been entered at the time of booking is mandatorily required to travel on the itinerary booked with such discount, whether individually or along with other persons travelling on the same PNR. In case of a ‘no show’ or cancellation of the booking by the relevant doctor or nurse, other passengers on the same PNR will be denied boarding and may only be allowed to travel with a fresh ticket (i.e. without discount) to be purchased at the relevant airport of departure</p>
          </li>
          <li>
            <strong>Applicability and Exclusions:</strong>

            <p>
              The Offer is applicable to one-way and round-trip bookings only for domestic travel for Doctors / Nurses /Policemen where tickets are purchased more than 7 (seven) days before the date of travel. The Offer is however, not applicable to allianceair’s group bookings for domestic travel
            </p>
          </li>
          <li>
            <strong>Changes in Booking:</strong>

            <p>
              The reservation booked under this category cannot be modified. For any modifications, a guest shall be required to cancel and making a booking afresh to get the applicable discount (subject to available inventory).
            </p>
          </li>
          <li>
            <strong>Transfer or Exchange:</strong>

            <p>
              This Offer is non-transferable, non-exchangeable and not cashable. The Airfare Offer cannot be clubbed with any other offer, scheme, or promotion related to airfare charges.
            </p>
          </li>
          <li>
            <strong>Conditions of Carriage:</strong>

            <p>
              All allianceair flight bookings made under this Offer shall be subject to allianceair’s Conditions of Carriage (“CoC”) available at
              {' '}
              <a href="/information/conditions-of-carriage.html">https://www.allianceair.in/information/conditions-of-carriage.html</a>
              . Nothing in these terms and conditions shall supersede anything contained in the CoC and in the event of any conflict or inconsistency with the CoC, the CoC shall prevail.
            </p>
          </li>
          <li>
            <strong>Right to withdraw:</strong>

            <p>
              allianceair reserves the right to withdraw or modify these terms, at any time, at its absolute discretion, without assigning any reason and without prior intimation. Withdrawal of the Offer, will not affect the tickets purchased during the Offer Period, prior to withdrawal of the Offer.
            </p>
          </li>
          <li>
            <strong>Governing Law:</strong>

            <p>
              This Offer will be governed by and construed in accordance with the laws of India, and all matters related to this Offer are subject to the exclusive jurisdiction of the courts at New Delhi.
            </p>
          </li>
        </ol>
        <p>
          <strong>Guest Consent:</strong>
          <p>
            The Guest:
            <br />
            (i) unconditionally and irrevocably agrees to these terms and conditions; and
            {' '}
            <br />
            (ii) consents that all information provided by the guest may be shared by allianceair with its agents, representatives, service providers, employees, and may be used to send promotional information pertaining to allianceair to the guest, in future.
          </p>
        </p>
      </CardHolder>

      <CardHolder
        id="paymentQuery"
        eventKey="paymentQuery"
        selectedEventKey={eventKey}
        header="How do I make a payment on allianceair website?"
      >
        <ul>
          <li>
            Choose your desired flight plans and proceed to make a reservation where you will enter your credit card details such as name of cardholder, card number, expiry date, and CVV.
          </li>
          <li>
            allianceair will connect to your credit card issuing bank’s website to verify if your card is secured by Verified by Visa or MasterCard SecureCode.
          </li>
          <li>
            A bank window will appear requesting a password.
          </li>
          <li>
            Once your password is verified you will be automatically directed back to allianceair’s reservation page to complete your booking.
          </li>
        </ul>

        <strong>Additional Charges</strong>
        <p>
          A nominal non-refundable fee of INR 250 per person per flight for Net Banking / Debit Cards & Credit Cards will be charged as a Convenience fee.
        </p>
        <p>
          <strong>Cards Accepted:</strong>
        </p>
        <ul>
          <li>
            MasterCard
          </li>
          <li>
            Visa
          </li>
        </ul>

      </CardHolder>

      <CardHolder
        id="paymentVisa"
        eventKey="paymentVisa"
        selectedEventKey={eventKey}
        header="What if I want to make a payment on the website through my VISA Debit Card?"
      >
        <p>
          Many debit cards can also be used as credit cards on our website thereby increasing the convenience of making payments for your allianceair bookings. Be sure to register them using Verified by Visa with your respective bank as well.
        </p>

      </CardHolder>

      <CardHolder
        id="masterSecure"
        eventKey="masterSecure"
        selectedEventKey={eventKey}
        header="What if my bank doesn’t offer Verified by Visa or MasterCard SecureCode?"
      >
        <p>
          It is mandatory for all credit cards issued in India to be verified by one or the other authentication services. If you are banking with an Indian bank and they do not offer this service we ask that you use an alternate credit card or another payment option. If your card is issued outside of India, your transaction may be processed without registering for one of the services. To continue to enjoy a hassle-free booking experience with added security, make sure to register for an authentication service (if you have a MasterCard or Visa Debit/Credit Card) with your respective bank.
        </p>
      </CardHolder>

      <CardHolder
        id="otherPayments"
        eventKey="otherPayments"
        selectedEventKey={eventKey}
        header="Which all are the other form of payments accepted at allianceair?"
      >
        <p>
          Debit cards, Credit cards, Net banking, Travel Vouchers (only allianceair), Wallet and UPI
        </p>
      </CardHolder>

      <CardHolder
        id="allianceairCurrency"
        eventKey="allianceairCurrency"
        selectedEventKey={eventKey}
        header="Which all currencies are accepted at allianceair?"
      >
        <p>
          INR
        </p>
      </CardHolder>

      <CardHolder
        id="carryCard"
        eventKey="carryCard"
        selectedEventKey={eventKey}
        header="Do I need to carry a copy of my credit/ debit card or the original copy on the date of travel?"
      >
        <p>
          Yes, passengers should carry their card at the time of check-in for verification purpose. In case, they have used someone else’s card to book ticket than we recommend our passengers to carry the copy of the credit/ debit card. Alternatively, in the absence of original card or card copy passenger may carry the statement of the card reflecting the transaction done for said allianceair reservations.
        </p>
        <p>
          Passengers may be denied boarding in case the card verification process is not complete.
        </p>
        <p>
          Guests who have used cards issued out of Indian Boundaries must carry the card or a photo copy of the card at the time of Check-in. Guests who have used such cards for making a Booking may receive a verification call. If the transaction remains unverified, the amount will be refunded and an email notification will be sent to make the payment towards such Booking through the prescribed alternate modes within the stipulated time, failing which the reservation may be cancelled. We strongly recommend that the Guests check the status of their Booking on the Website before travel.
        </p>
      </CardHolder>
      <CardHolder
        id="additionalCharges"
        eventKey="additionalCharges"
        selectedEventKey={eventKey}
        header="Are there any additional charges if I make my payment through the call centre?"
      >
        <p>
          A booking fee of INR 250 per passenger per sector (or equivalent) will be applicable for all bookings made from the call center and airport ticketing counter
        </p>
      </CardHolder>

      <CardHolder
        id="callCenter"
        eventKey="callCenter"
        selectedEventKey={eventKey}
        header="Can I book through the call center using my credit card for another guest?"
      >
        <p>
          While it is recommended to pay for your own flight ticket, you can pay for another guest using your credit card. However, in such a case the guest should carry a photocopy of (front side only) of the credit card used for purchase of the tickets attested by the credit card holder for verification at the Airport check-in counter.
        </p>
      </CardHolder>
      <CardHolder
        eventKey="convenienceFeeReason"
        id="convenienceFeeReason"
        selectedEventKey={eventKey}
        header="Why am I charged a convenience fee?"
      >
        <p>
          Please note that, in compliance of the order of the Honourable Supreme Court dated 23.01.2013 in Civil Appeal No. 8771 of 2012, allianceair does not charge any Transaction Fee from its guests.
        </p>
        <p>
          A convenience fee is collected by the airlines for establishing, maintaining and operating the online booking system, to enable the passengers to book the air tickets online while using a credit/debit card. This fees includes the charges paid by the airlines to the concerned bank (and it varies from one bank to another) for availing of such facility.
        </p>
      </CardHolder>

      <CardHolder
        id="convenienceFee"
        eventKey="convenienceFee"
        selectedEventKey={eventKey}
        header="What is Convenience Fee?"
      >
        <p>
          A convenience fee of INR 250 per person per flight for Net banking/Credit Cards/Debit Cards payments is collected by the airlines for establishing, maintaining and operating the online flight booking system. This fee includes the charges paid by the airlines to the concerned Bank (varies from one Bank to another) for availing of such facilities. A convenience fee of INR 250 is charged per person per sector on all bookings made through our mobile app and website.
        </p>
        <p>
          Convenience Fee is non-refundable.
        </p>
      </CardHolder>
      <CardHolder
        id="visamaster"
        eventKey="visamaster"
        selectedEventKey={eventKey}
        header="What is Verified by Visa (VBV) or MasterCard Secure Code (MSC)?"
      >
        <p>
          Visa and MasterCard that allows you to complete online transaction securely. By authenticating and verifying your credit card details with an additional password it reduces the possibility of credit card fraud. This service is free of charge for you, the credit card holder.
        </p>
        <strong>
          How to Register
        </strong>
        <p>
          If you have a Visa or MasterCard go to your respective bank’s website where you will be asked to follow a simple step by step procedure to register for Verified by Visa, ProtectBuy or MasterCard Secure Code. After entering your credit card details you will be asked to create a password that will be used every time you make an online payment. Once complete you can continue making payments online.
        </p>

      </CardHolder>
      {/* </Accordion> */}
    </div>
  );
}
